module.exports = __webpack_public_path__ + "img/icon30.aab6deed.png";